import React from 'react'
import { Link } from 'gatsby'
import { Container, Row, Col } from 'reactstrap';

import css from './footer.module.css';
import logo from '../img/template/logo_do_paty.svg';

const Footer = () => (
  <footer className={css.footer}>
    <Container>
      <Row>
        <Col sm={12}>
          <img src={logo} alt="logo" className={css.logo} />
          <span className={css.span}>WuXing TCM Masters / PANAX MEDICAL s.r.o. – ing. mgr. PETR MOKRÝ</span>
          <span className={css.text}>Školící středisko Wu Xing TCM Masters / areál VUT –  Kraví Hora / Rybkova 23 (budova 19) / Brno</span>
          <span className={css.text}>e-mail petr.mokry@gmail.com / tel. +420 776 670 717</span>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;
